import axios from 'axios';
import { toast } from 'react-toastify';
import $ from 'jquery';
import Response from './locale/res.json';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import 'jspdf/dist/polyfills.es.js';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import lang from './lang';

const moment = require('moment');

const urlArray = ['/Parcel/GetPDFById','/Entity/GetAll','/InstalacaoVinica/GetInstalacaoFromNumberOrDesignation','SIVDP/GetPendingEvaluation','/SIVDP/gettitolo','/SIVDP/evelution_details','/SIVDP/pending_evelution_count_list','/Parcel/GetVersionsById','/Levantamento/GetDetail' , '/Entidades/ViewEntidadesFiscalizacao']

// alert(process.env.NODE_ENV);
// alert(process.env.REACT_APP_API_URL);

// axios.defaults.baseURL = 'http://10.0.4.62:91/api';
// axios.defaults.baseURL = 'https://10.0.4.62:97/api';
// axios.defaults.baseURL = "https://apiivpd.yiipro.com/api";
// axios.defaults.baseURL   = "https://ivdp.yiipro.com/api/api";
// axios.defaults.baseURL = 'https://ivdpapi.azurewebsites.net/api';
// axios.defaults.baseURL = 'http://ivdp.ambisig.com/api/api';
axios.defaults.baseURL = process.env.REACT_APP_API_URL;


let count_process = 0;

let searchPesquisar = '';

$(document).ready(() => {
  $(document).on('click', '.k-i-more-vertical', (e) => {
    updateAdvanceFilter();
  });

  $(document).on('click', '.k-i-calendar', (e) => {
    // alert("hgfvytv");
  });

  function updateAdvanceFilter() {
    // var html = $(".k-animation-container-relative").html();
    // alert(html)
    $('.k-space-right').find('input').attr('placeholder', 'Pesquisar');
    $('.k-columnmenu-item').html('<span className="k-icon k-i-filter"></span>Filtro');
    $('.k-columnmenu-actions').find('.k-button').text('Limpar Filtros');
    $('.k-columnmenu-actions').find('.k-button:first-child').addClass('btn-ivdp-secondary');
    $('.k-columnmenu-actions').find('.k-primary').text('Filtrar');
    $('.k-columnmenu-actions').find('.k-primary').addClass('btn-ivdp-primary');
    // $('.k-state-default').find('.k-checkbox-label').first().text('Selecionar todos');
    $('.k-animation-container-relative').css('z-index', '99999');
  }
  
  $(document).on('hover', '.dropdown-menu', (e) => {
    e.stopPropagation();
  });
  $(document).on('click', '.k-i-more-vertical', (e) => {
    updateAdvanceFilter();
  });
  // make it as accordion for smaller screens
  if ($(window).width() < 992) {
    $('.dropdown-menu span').click(function (e) {
      e.preventDefault();
      if ($(this).next('.submenu').length) {
        $(this).next('.submenu').toggle();
      }
      $('.dropdown').on('hide.bs.dropdown', function () {
        $(this).find('.submenu').hide();
      });
    });
  }

  $(document).on('click', '.closetooltip', function () {
    $(this).closest('.dropdown-menu').removeClass('show');
  });

  $(document).on('click', '.parcelEntityFilter', () => {
    $('.ant-select-dropdown').addClass('parcelEntityFilter');
    $('.ant-select-dropdown-placement-bottomLeft').addClass('parcelEntityFilter');
  });

  function checkAlllabel() {
    $('.input-label').each(function () {
      const label = $(this);
      const placeholder = label.text();

      var input = $(label).closest('div').find('input').attr('placeholder', placeholder);
      if (input === undefined) var input = $(label).closest('div').find('select').attr('placeholder', placeholder);

      if ($(input).val() === '') {
        $(this).addClass('hidden');
      } else {
        $(this).removeClass('hidden');
      }
    });
  }
  checkAlllabel();
  $(document).on('click', '.outer-space', () => {

  });
});

const money = {
  format: (amount, decimalCount = 3, decimal = ',', thousands = '.') => {
    try {
      amount = parseFloat(amount);
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 3 : decimalCount;
      const negativeSign = amount < 0 ? '-' : '';
      const i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      const j = (i.length > 3) ? i.length % 3 : 0;
      return `${negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '')}`;
    } catch (e) {
      // console.log(e)
      return amount;
    }
  }
};

const EntityList = {

  getEntityList: async (modulename, filter = null, nif = null) => {
    const data = {
      modulename,
      SortBy: 'nome',
      IsSortTypeDESC: false,
      IsPagination: true,
      Page: 1,
      PageSize: 40,
      Filters: {
        searchString: filter || null,
        searchStringNIF: nif || null
      }
    };
    const res = await apiCall.requestApi('/Entity/GetAll', data, 'post');
    // console.log("FIILTER", res)
    if (res) {
      const entity_row = {};
      res.map((r) => {
        entity_row[r.nif] = r;
      });
      return {
        entityList: res,
        entity_row
      };
    }
  }
};

const checkAlllabelall = () => {
  $('.input-label').each(function () {
    const label = $(this);
    const placeholder = label.text();
    let input = $(label).closest('div').find('input').attr('placeholder', placeholder);
    if (input === undefined) input = $(label).closest('div').find('select').attr('placeholder', placeholder);
    if ($(input).val() === '') {
      $(this).addClass('hidden');
    } else {
      $(this).removeClass('hidden');
    }
  });
};

const deleted = 0;
const startguoupsum = () => {
  if (deleted === 0) {
    // var cross = $(".k-i-group-delete").first()
    // $(cross).trigger('click');
    // deleted = 1;
  }
};

const startguoup = {
  onedelete: () => {
    startguoupsum();
  }
};

const lablecheck = {
  setlable: () => {
    checkAlllabelall();
  }
};

const appHeader = () => {
  const authorizeToken = window.localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${authorizeToken}`
  };
  //parseJwt(authorizeToken)
  return headers;
};
const parseJwt = (token) => {  
  if(token != null){
    const decode = JSON.parse(atob(token.split('.')[1]));
    console.log(decode);
    if (decode.exp * 1000 < new Date().getTime()) {
       // logoutAction();
        console.log('Time Expired');
        handleLogout()
    }
  }   
  
};

const handleLogout = () => {
  let data = {
      "username": window.localStorage.getItem('username'),
      "Password": "0x7CCEBE3E8550AE16ABBEA1BD8014F8DEE2BF5EFBA243682E86BF99873245980C5B570E97DBB9C1C31C2F82CA4110348736EB5266F76F278410F3EABF7B1FA1AE"
  }
  apiCall.requestApi("/User/AuthenticateLogout", data, 'post')
  window.localStorage.removeItem('token');
  window.location = '/'
  const token = window.localStorage.getItem('token')
}

const errorCheck = {
  error: (data) => {
    handleError(data);
    
  }
};

const handleError = (data) => {
  let object;
  let foundelement = false;
  $('.todeleteerrro').each(function () {
    $(this).remove();
  });
  console.log(data.errors);
  $.each(data.errors, (key, value) => {
    object = null;
    key = key.replace('$.', '');
    if ($(`select[name=${key}]`).length) object = $(`select[name=${key}]`);
    else if ($(`textarea[name=${key}]`).length) object = $(`textarea[name=${key}]`);
    else object = $(`input[name=${key}]`);

    if (key === 'DOB') {
      object = $('.ant-picker').parent('div');
    }
    if (object !== null) {
      foundelement = true;
    }
    object.addClass('errorRed');
    if ($(object).closest('span').find('.k-label').text()) {
      value[0] = `${$(object).closest('span').find('.k-label').text()} É necessário`;
    }
    object.after(`<span class='errormess todeleteerrro' style='width:100%; color:red'>${value[0]} </span>`);
  });
};

$('body').on('click', '.errorRed', function () {
  $(this).next('.errormess').remove();
  $(this).removeClass('errorRed');
});

const getResObject = {
  get: (url) => {
    const res = Response[url];
    if (res) {
      return res;
    }
    return [];
  }
};

const setSomeKeys = (data) => {
  // debugger;
  // return data;
  if (Array.isArray(data)) {
    for (let i = 0; i < data.length; i++) {
      const element = data[i];
      data[i] = setSomeKeys(element);
    }
  } else if (data instanceof Object) {
    const objectKeys = Object.keys(data);
    for (let j = 0; j < objectKeys.length; j++) {
      const _k = objectKeys[j];
      if (Array.isArray(data[_k])) {
        for (let l = 0; l < data[_k].length; l++) {
          const el = data[_k][l];
          data[_k][l] = setSomeKeys(el);
        }
      } else if (data[_k] instanceof Object) {
        data[_k] = setSomeKeys(data[_k]);
      } else {
        if (data[_k] === 'null' || data[_k] === 'Null' || data[_k] === null || data[_k] === undefined || data[_k] === '') {
          data[_k] = '';
        }
        if ((_k === 'fatorCasta' || _k === 'fatorDOPorto') && data[_k] === '') {
          data[_k] = 1;
        }
        if (_k === 'status') {
          if (data[_k] == 1 || data[_k] === 'Active') {
            data[_k] = 'Ativo';
          } else {
            data[_k] = 'Inativo';
          }
        }
      }
    }
    // Object.keys(data).map((_k) => {
    //     if (Array.isArray(data[_k])) {
    //         data[_k].map((_r) => {
    //             data[_k] = await setSomeKeys(_r);
    //         })
    //     } else if (typeof data[_k] == 'object') {
    //         data[_k] = await setSomeKeys(data[_k]);
    //     } else {
    //         if (data[_k] === "null" || data[_k] === "Null" || data[_k] === null || data[_k] === undefined || data[_k] === '') {
    //             data[_k] = 'nd'
    //         }
    //         if (data[_k] === true) {
    //             data[_k] = 'Sim'
    //         }
    //         if (data[_k] === false) {
    //             data[_k] = 'Não'
    //         }
    //     }
    // })
  }
  return data;
};

const Converter = {
  dateConvert: (date, format) => {
    let convertDate = '';
    convertDate = moment(date).format(format);
    if (convertDate === 'Invalid date') convertDate = 'nd';
    return convertDate;
  }
};

const apiCall = {
  
  requestApi: async (url, data, method = 'post') => {
    try {
      // //console.log(count_process + "+++++++" + url);
      // if (!urlArray.includes(url)) {
      //   const dataKeys = url + JSON.stringify(data);
      //   if (dataKeys === searchPesquisar) return;
      //   searchPesquisar = dataKeys;
      // }
      const authorizeToken = window.localStorage.getItem('token');
      parseJwt(authorizeToken);
      if (data.Filters === undefined) count_process++;
      $('.Display_loadiing').show();
      if (window.localStorage.getItem('vpn') === 0) {
        const res = Response[url];
        count_process--;
        // console.log(count_process + "....." + url);
        if (count_process <= 0) {
          count_process = 0;
          $('.Display_loadiing').hide();
        }
        if (res) {
          // console.log("res", url, res.length)
          window.localStorage.setItem('table_total', 1000);
          return res;
        }
        return [];
      } if (url === 'allservice/DouroPort') {
        const res = Response[url];
        count_process--;
        //  //console.log(count_process + "....." + url);
        if (count_process <= 0) {
          count_process = 0;
          $('.Display_loadiing').hide();
        }
        if (res) {
          return res;
        }
      }
      let response = [];
      if (method === 'post') {
        // data.FiltersIn = null
        response = await axios.post(`${url}`, data,
          { headers: appHeader() });
      } else if (method === 'get') {
        const params = new URLSearchParams(data).toString();
        if (params === '') {
          response = await axios.get(`${url}`,
            { headers: appHeader() });
        } else {
          response = await axios.get(`${url}?${params}`,
            { headers: appHeader() });
        }
      }
      if (data.Filters === undefined) count_process--;
      //  //console.log(count_process + "....." + url);
      if (count_process <= 0) {
        count_process = 0;
        $('.Display_loadiing').hide();
      }

      if (response.data.success === true) {
        if (response.data.data || response.data.data === 0) {
          if (response.data.pagination) {
            window.localStorage.setItem('table_total', response.data.pagination.total);
          }
          // console.log("response.data.data",response.data.data)
          const Finaldata = setSomeKeys(response.data.data);
          if(response.data.message === 'Auto concluído com sucesso') toast.success(response.data.message);
          // console.log(url, Finaldata);
          return Finaldata;
        }
        if(response.data.message) toast.success(response.data.message);
        if (response.pagination) {
          window.localStorage.setItem('table_total', response.pagination.total);
        }
        // console.log("response.data",response.data)
        const Finaldata = setSomeKeys(response.data);
        // console.log(url, Finaldata);
        return Finaldata;
      }
      if ($.trim(response.data.message) !== '') toast.error(`${response.data.message}`);
      if (response.error.response !== '') toast.error(`${response.error.response}`);
    } catch (error) {
      if (data.Filters === undefined) count_process--;
      // console.log(count_process + "....." + url);
      if (count_process <= 0) {
        count_process = 0;
        $('.Display_loadiing').hide();
      }
      if (error.response) {
        // console.log("err", error.response)
        error.response
                    && handleError(error.response.data);
        if (error.response.statusText === 'Unauthorized') {
          window.localStorage.removeItem('token');
          window.location = '/';
        }
      }
    }
  },
};

const getvaluewithtype = (val) => {
  if ($.isNumeric(val)) {
    return Number(val);
  }
  return val;
};

const exportFiles = {
  pdfDownloader: (dataList, columnList) => {
    const unit = 'pt';
    const size = 'A4'; // Use A1, A2, A3 or A4
    const orientation = 'landscape'; // portrait or landscape

    const marginLeft = 5;
    const doc = new jsPDF(orientation, unit, size);
    doc.setFontSize(7);

    const title = 'IVDP Report';
    const headerKeys = [];
    columnList.map((_row, ind) => headerKeys.push(lang.langCheck.langRequest(_row.field)));
    const headers = [headerKeys];
    const data = dataList.map((elt) => headerKeys.map((_k) =>

    // if(elt[_k].includes("€")){
    //    return elt[_k].replace("€","&#xA4");
    //     let a = elt[_k].split(' ')
    //     return [a[0]]
    // }else{
      [elt[_k]]
      // }
    ));
    const content = {
      startY: 50,
      head: headers,
      body: data,
      theme: 'grid',
      headStyles: { fontSize: 6, halign: 'center', whiteSpace: 'nowrap' },
      bodyStyles: { fontSize: 6, halign: 'center', border: '1px solid' }
    };

    doc.text(title, marginLeft, 5);
    doc.autoTable(content);
    doc.save('report-IVDP.pdf');
  },
  ExcelDownload: (dataList, columnList) => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const fileName = 'IVDP Report';
    const headerKeys = [];
    columnList.map((_row, ind) => headerKeys.push(lang.langCheck.langRequest(_row.field)));
    const csvData = dataList.map((elt) => {
      const dataObj = {};
      for (let i = 0; i < headerKeys.length; i++) {
        const ele = headerKeys[i];
        dataObj[ele] = elt[ele];
      }
      return dataObj;
    });
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  }
};

const getAllFilters = {
  addBoth: (customfilters, tlkfilter, columnkeyMap, data, booleankeys = {}, filters = {}, entityFilter = {}) => {
    Object.keys(columnkeyMap).map((key) => {
      key = key.toLowerCase();
      filters[key] = null;
      if (!booleankeys[key]) {
        filters[`${key}multiple`] = null;
        filters[`${key}like`] = null;
      }
    });
    customfilters.filterCheckbox
            && Object.keys(customfilters.filterCheckbox).map((key) => {
              filters[entityFilter[key]] = customfilters.filterCheckbox[key];
            });
    customfilters.filters
            && Object.keys(customfilters.filters).map((key) => {
              filters[`${(key).toLowerCase()}like`] = customfilters.filters[key];
            });

    if (tlkfilter.filter && tlkfilter.filter.filters && tlkfilter.filter.filters.length > 0) {
      const columnkeyMaprev = {};
      for (const key in columnkeyMap) {
        columnkeyMaprev[columnkeyMap[key]] = key;
      }
      let tkkey = '';
      let tkkeyvalues = [];
      tlkfilter.filter.filters.map((_row, i) => {
        tkkey = '';
        tkkeyvalues = [];
        if (_row.filters && _row.filters.length > 0) {
          _row.filters.map((_srow, k) => {
            tkkey = _srow.field;
            tkkeyvalues.push(getvaluewithtype(_srow.value));
          });
          tkkey = columnkeyMaprev[tkkey];
          tkkey = tkkey.toLowerCase();

          if (tkkeyvalues.length === 1) {
            filters[tkkey] = tkkeyvalues[0];
          } else {
            filters[`${tkkey}multiple`] = tkkeyvalues;
          }
        }
      });
    }
    if (tlkfilter && tlkfilter.sort && tlkfilter.sort.length > 0) {
      data.SortBy = tlkfilter.sort[0].field;
      data.IsSortTypeDESC = tlkfilter.sort[0].dir !== 'asc';
      data.Page = tlkfilter.skip ? (tlkfilter.skip / tlkfilter.take + 1) : 1;
      data.PageSize = tlkfilter.take ? tlkfilter.take : 100;
    }
    data.Filters = filters;
    return data;
  }
};

const goto = {
  onto: (url) => {
    window.location = url;
  },
  newTab: (url) => {
    const link = document.createElement('a');
    link.target = '_blank';
    link.href = url;
    link.click();
  },
  createChart: () => {

  }
};

export default {
  apiCall, lablecheck, startguoup, errorCheck, getResObject, EntityList, getAllFilters, money, goto, exportFiles, Converter
};
